<template>
  <div>
    <navbar/>
    <page-header/>
  </div>
</template>

<script>
//import {http} from 'axion'
import Nav from "./Nav";
import Header from "./Header"

export default {
  name: "Home",
  components: {
    "navbar": Nav,
    "page-header": Header
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Home.vue